import React from 'react';
import { KTSVG } from '../../../../_metronic/helpers/components/KTSVG';
import './FaceScanHeroPanel.css';

interface MetricItem {
  svgPath: string;
  label: string;
  description: string;
  accent: string; // CSS class for accent color
}

const METRICS: MetricItem[] = [
  {
    svgPath: '/media/icons/duotune/medicine/med001.svg',
    label: 'Heart Rate',
    description: 'Resting beats per min',
    accent: 'accent-red',
  },
  {
    svgPath: '/media/icons/duotune/medicine/med004.svg',
    label: 'Blood Oxygen',
    description: 'SpO2 % in blood',
    accent: 'accent-blue',
  },
  {
    svgPath: '/media/icons/duotune/medicine/med002.svg',
    label: 'Blood Pressure',
    description: 'Systolic & diastolic',
    accent: 'accent-purple',
  },
  {
    svgPath: '/media/icons/duotune/medicine/med003.svg',
    label: 'Respiration Rate',
    description: 'Breaths per minute',
    accent: 'accent-teal',
  },
  {
    svgPath: '/media/icons/duotune/graphs/gra004.svg',
    label: 'HRV Score',
    description: 'Recovery & resilience',
    accent: 'accent-green',
  },
  {
    svgPath: '/media/icons/duotune/general/gen044.svg',
    label: 'Stress Index',
    description: 'Nervous system load',
    accent: 'accent-orange',
  },
  {
    svgPath: '/media/icons/duotune/medicine/med007.svg',
    label: 'HbA1c & Blood Sugar',
    description: '3-month glucose risk',
    accent: 'accent-pink',
  },
  {
    svgPath: '/media/icons/duotune/medicine/med005.svg',
    label: 'Hypertension Risk',
    description: 'Pressure risk score',
    accent: 'accent-indigo',
  },
  {
    svgPath: '/media/icons/duotune/medicine/med009.svg',
    label: 'BMI & Body Fat',
    description: 'Composition & BMR',
    accent: 'accent-lime',
  },
  {
    svgPath: '/media/icons/duotune/medicine/med006.svg',
    label: 'Skin Health',
    description: 'AI skin analysis',
    accent: 'accent-amber',
  },
];

const FaceScanHeroPanel: React.FC = () => {
  return (
    <div className="fhp-root">
      {/* ── Hero text ── */}
      <div className="fhp-hero">
        <h2 className="fhp-headline">
          Know Your Health<br />
          <span className="fhp-headline-accent">in 60 Seconds</span>
        </h2>

        <p className="fhp-subtext">
          Our AI camera technology reads subtle changes in your face to measure{' '}
          <strong>30+ vital health parameters</strong> — instantly and accurately,
          with no wearables or blood tests required.
        </p>

        <div className="fhp-stats-row">
          <div className="fhp-stat">
            <span className="fhp-stat-num">60s</span>
            <span className="fhp-stat-label">Scan duration</span>
          </div>
          <div className="fhp-stat-divider" />
          <div className="fhp-stat">
            <span className="fhp-stat-num">30+</span>
            <span className="fhp-stat-label">Health parameters</span>
          </div>
          <div className="fhp-stat-divider" />
          <div className="fhp-stat">
            <span className="fhp-stat-num">AI</span>
            <span className="fhp-stat-label">Powered analysis</span>
          </div>
        </div>
      </div>

      {/* ── Metrics grid ── */}
      <div className="fhp-metrics-section">
        <div className="fhp-section-title">
          <KTSVG path="/media/icons/duotune/graphs/gra004.svg" className="svg-icon-6 me-1" />
          What you'll receive in your report
        </div>

        <div className="fhp-metrics-grid">
          {METRICS.map((m) => (
            <div key={m.label} className={`fhp-metric-card ${m.accent}`}>
            <div className="fhp-metric-icon">
              <KTSVG path={m.svgPath} className="svg-icon-3" />
            </div>
            <div className="fhp-metric-body">
              <span className="fhp-metric-label">{m.label}</span>
              <span className="fhp-metric-desc">{m.description}</span>
            </div>
          </div>
          ))}
        </div>
      </div>

      {/* ── Footer note ── */}
      <div className="fhp-disclaimer">
        <KTSVG path="/media/icons/duotune/general/gen044.svg" className="svg-icon-7 me-1 opacity-50" />
        This assessment is indicative, not diagnostic. Consult a healthcare professional for medical advice.
      </div>
    </div>
  );
};

export default FaceScanHeroPanel;
